// extracted by mini-css-extract-plugin
export default {"profilelist":"UFhkFYuZHB51M1uAblFi","digitfocus":"HeytkU7kES4tmbbM5HUw"};